import { constants } from "@newsela/angelou";

const { colors } = constants;

const darkBlue = colors.ui.core[700];
const green = colors.ui.green[500];
const red = colors.ui.red[500];

// Used in the annotation card color picker for non-selected colors.
export const annotationColorsLighter = {
  yellow: "rgba(253, 173, 47, 0.15)",
  blue: "rgba(133, 183, 253, 0.15)",
  green: "rgba(37, 192, 155, 0.15)",
  pink: "rgba(255, 184, 208, 0.2)",
};

// Used as background colors for text highlighting and selected color in the color picker.
export const annotationColors = {
  yellow: "rgba(253, 173, 47, 0.3)",
  blue: "rgba(133, 183, 253, 0.25)",
  green: "rgba(37, 192, 155, 0.25)",
  pink: "rgba(255, 184, 208, 0.4)",
};

// Used for borders, or the checkmark in the color picker.
export const annotationColorsDarker = {
  yellow: "#B87816",
  blue: darkBlue,
  green,
  pink: red,
};

// Translating the color values from the Read page plugin to match the redesign.
export const annotationColorValues = {
  blue: "blue",
  pink: "red",
  green: "springgreen",
  yellow: "yellow",
};

export const annotationPenNameValues = {
  blue: "blue",
  red: "pink",
  springgreen: "green",
  yellow: "yellow",
};
